import resourceService from './resource_service';

const modelName = 'site-ability';

const attributes = {};

const relationships = {
  site: {
    jsonApi: 'hasOne',
  },
  ability: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
